import './marketing.css';
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';
import { images } from '../config/imagePaths';

function DigitalMarketing() {
  return (
    <>
      <Seo
        title="Digital Marketing"
        description="Digital marketing services from AOK Communications to help grow your business online."
      />
      <Header />

      <main className="services-page page-content">
        <section className="service-section reveal-left">
          <div className="text-content">
            <h1>Social Media Management</h1>
            <p>
              Social media is one of the most powerful ways to market your business — almost everyone is online,
              and your brand should be too.
            </p>
            <p>
              But staying consistent and engaging takes time. AOK Communications handles it all — so you can focus on growing your business.
            </p>
          </div>
          <img src={images.services.marketing1} alt="Marketing Campaign" className="image-balanced img-zoom-wrap reveal-right" />
        </section>

        <section className="service-section reveal-right">
        <img src={images.services.marketing2} alt="Content Days" className="image-balanced img-zoom-wrap reveal-left" />
        <div className="text-content">
          <h2>Content Days</h2>
          <p>
            Professional content production sessions to capture high-quality media for your brand — videos, reels, photos, and more.
            A must-have for businesses wanting to stay visually relevant and engaging online.
          </p>
        </div>
      </section>

        <section className="service-section reveal-left">
          <div className="text-content">
            <h2>Marketing Campaigns</h2>
            <p>
              Need campaign support from idea to execution?
              We’ll guide your campaign strategy and manage everything from copy to content to launch.
            </p>
            <p>
              <a href="mailto:enquiries@aokmentoring.com">Email us to get started.</a>
            </p>
          </div>
          <img src={images.services.marketingHero} alt="Marketing Campaign" className="image-balanced img-zoom-wrap reveal-right" />
        </section>

        <section className="service-section reveal-right">
        <img src={images.services.marketing3} alt="Content Days" className="image-balanced img-zoom-wrap reveal-left" />
        <div className="text-content">
          <h2>Events</h2>
          <p>
            At AOK Communications, we create impactful event marketing strategies that bring your brand to life. From concept to execution, we handle every detail to ensure your event not only runs smoothly but leaves a lasting impression. Whether it’s a corporate launch, community activation, or team experience, we focus on building engagement, visibility, and genuine connections that strengthen your brand story. 
          </p>
        </div>
      </section>
      </main>

      <Footer />
    </>
  );
}

export default DigitalMarketing;
